module.exports = __webpack_public_path__ + "static/img/csias-icon.0e95fcd9.png";